import { motion } from "framer-motion";

interface AvailabilityPillProps {
  text: string;
  accent?: "teal" | "amber";
}

export function AvailabilityPill({ text, accent = "teal" }: AvailabilityPillProps) {
  const isTeal = accent === "teal";

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 0.6, duration: 0.4 }}
      className={`inline-flex items-center gap-2 rounded-full border px-4 py-1.5 ${
        isTeal
          ? "border-primary/30 bg-primary/5"
          : "border-amber-500/30 bg-amber-500/5"
      }`}
    >
      <span className="relative flex h-2 w-2">
        <span
          className={`animate-ping absolute inline-flex h-full w-full rounded-full opacity-75 ${
            isTeal ? "bg-primary" : "bg-amber-500"
          }`}
        />
        <span
          className={`relative inline-flex rounded-full h-2 w-2 ${
            isTeal ? "bg-primary" : "bg-amber-500"
          }`}
        />
      </span>
      <span
        className={`text-xs font-body font-semibold tracking-wide ${
          isTeal ? "text-primary" : "text-amber-500"
        }`}
      >
        {text}
      </span>
    </motion.div>
  );
}
